import React from 'react';

import { Info as InfoIcon } from '@mui/icons-material';
import { Grid, IconButton, Paper, Typography } from '@mui/material';

import { Nullable } from '@clearverify/types';

import { Tooltip } from 'src/components/common';
import { RevenueShareSettingHost, useRevenueShare } from 'src/hooks/revenueShare';
import { SxProp } from 'src/types/mui';
import { getDefaultPaperBorder } from 'src/utils/theme';

interface RevenueShareCardProps {
  company: Nullable<RevenueShareSettingHost>;
}

export const RevenueShareCard: React.FC<RevenueShareCardProps> = ({ company }) => {
  const { revenueShareValueText } = useRevenueShare(company);

  return (
    <Paper elevation={0} sx={getDefaultPaperBorder}>
      <Grid container>
        <Grid size={9}>
          <Grid padding="16px 24px">
            <Grid>
              <Typography component="h3" variant="body1">
                Revenue Share
              </Typography>
            </Grid>
            <Grid>
              <Typography component="p" sx={revenueShareStyles}>
                {revenueShareValueText}
              </Typography>
            </Grid>
            <Grid>
              <Typography variant="body2" color="text.secondary">
                You get from any request
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid mt={1} pr={1} display="flex" justifyContent="end" alignItems="start" size={3}>
          <Tooltip title={TOOLTIP_TEXT} arrow placement="right">
            <IconButton>
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    </Paper>
  );
};

const revenueShareStyles: SxProp = {
  fontWeight: 500,
  fontSize: '34px',
  lineHeight: '42px',
  letterSpacing: '0.25ppx',
};

const TOOLTIP_TEXT =
  'Per your agreement, you receive a revenue share on verifications requested regarding your employees.';
